import Vue from "vue";
import App from "./App.vue";
import router from "./router/index";
import store from "./store/index";
// 其他页面在使用axios的时候直接  this.$post就可以了
import { post, get } from "./axios/index";
Vue.prototype.$post = post;
Vue.prototype.$get = get;
// 多语言
import i18n from "./commonJs/i18n";

// 移动端处理300毫秒延迟问题
import FastClick from "fastclick";
FastClick.attach(document.body);
import Scroll from "./components/BScroll/scroll/scroll";
Vue.component("scroll", Scroll);
import "lib-flexible/flexible";
import "./commonJs/vant";
// facebook
import FBSignInButton from "vue-facebook-signin-button";
Vue.use(FBSignInButton);

import VueDND from "awe-dnd";
Vue.use(VueDND);

Vue.use(require("vue-wechat-title"));

import * as VueGoogleMaps from "vue2-google-maps";
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyCP8wu3wUtUEeHtar4qE7ftbWGRdcYKn80",
    // libraries: "places",
    language: store.getters.language == "en" ? "en_US" : "zh_CN", //en_US
    libraries: "places,drawing,visualization"
  }
});

import "./assets/css/common.less";
import "./assets/css/css.css";

Vue.prototype.httpUrl =
  location.origin.indexOf("localhost") != -1 ||
  location.origin.indexOf("192.168.1") != -1
    ? "https://www.feifu.fun/"
    : location.origin; // 开发服务器取的图片路径
// Vue.prototype.httpUrl = 'http://192.168.1.121/' // 线上服务器取的图片路径
Vue.config.productionTip = false;

Vue.prototype.enter ="app";

Vue.prototype._back = () => {
  router.back();
};

// 跳转页面
Vue.prototype._linkFun = (path = "", name = "", query = {}, params = {}) => {
  router.push({
    path: path,
    name: name,
    query: query,
    params: params
  });
};

// 补零
Vue.prototype._zeroFill = value => {
  return value < 10 ? "0" + value : value + "";
};

// 号码格式处理
Vue.prototype._phoneFormat = num => {
  let firstStr = (num + "").substr(0, 1);
  let returnNum = "";
  if (firstStr == "0") {
    returnNum = num
      .toString()
      .replace(/\s/g, "")
      .replace(/(0?\d{4})(\d{3})(\d{4})/, "$1 $2 $3");
  } else {
    returnNum = num
      .toString()
      .replace(/\s/g, "")
      .replace(/(\d{3})(\d{3})(\d{4})/, "$1 $2 $3");
  }
  return returnNum;
};

// 比索转换成人民币
Vue.prototype._PHPtoRMB = (a = 0, b = 0) => {
  var c = 0,
    d = a.toString(),
    e = b.toString();
  try {
    c += d.split(".")[1].length;
  } catch (f) {
    // console.log(11)
  }
  try {
    c += e.split(".")[1].length;
  } catch (f) {
    // console.log(11)
  }
  var mun =
    (Number(d.replace(".", "")) * Number(e.replace(".", ""))) / Math.pow(10, c);
  return (Math.round(mun * 100) / 100).toFixed(2);
};

// 输入框金额校验
Vue.prototype._formatter = value => {
  /* eslint-disable */
  value = value.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
  value = value.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
  value = value
    .replace(".", "$#$")
    .replace(/\./g, "")
    .replace("$#$", ".");
  value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3"); // 只能输入两个小数
  if (value.indexOf(".") < 0 && value != "") {
    // 以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
    value = parseFloat(value);
  }
  return value;
};

// 手机号码星号处理
Vue.prototype._phoneDispose = value => {
  //
  if (value) {
    return value.substring(0, 4) + " *** " + value.substring(value.length - 4);
  } else {
    return value;
  }
};

// 打电话
Vue.prototype._telephone = value => {
  window.location.href = "tel:" + value;
  console.log("tel:" + value);
};

// 日期格式处理
Vue.prototype._dateFormat = value => {
  let year = value.getFullYear();
  let month =
  value.getMonth() + 1 < 10
      ? "0" + (value.getMonth() + 1)
      : value.getMonth() + 1;
  let day = value.getDate() < 10 ? "0" + value.getDate() : value.getDate();
  return year + "-" + month + "-" + day;
};

Vue.prototype._formatDate = (date, fmt ="yyyy-MM-dd") => {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  }
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + ''
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : Vue.prototype._zeroFill(str))
    }
  }
  return fmt
}

// 删除单页面缓存
Vue.prototype._vnodeKeepAlive = (to, from, next, vnode, name = "") => {
  if (vnode && vnode.data.keepAlive && to.name == name) {
    if (
      vnode.parent &&
      vnode.parent.componentInstance &&
      vnode.parent.componentInstance.cache
    ) {
      if (vnode.componentOptions) {
        var key =
          vnode.key == null
            ? vnode.componentOptions.Ctor.cid +
              (vnode.componentOptions.tag
                ? `::${vnode.componentOptions.tag}`
                : "")
            : vnode.key;
        var cache = vnode.parent.componentInstance.cache;
        var keys = vnode.parent.componentInstance.keys;
        if (cache[key]) {
          if (keys.length) {
            var index = keys.indexOf(key);
            if (index > -1) {
              keys.splice(index, 1);
            }
          }
          delete cache[key];
        }
      }
    }
    from.meta.keepAlive = true;
  }
  next();
};

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
